import React from 'react'
// import PropTypes from 'prop-types'
import classNames from 'classnames'
import PhoneInput from './react-phone-input-2'
import './phoneField.sass'
import './field.sass'
import './flags.sass'
import './react-phone-input.css'

class PhoneField extends React.Component {
  render() {
    return (
      <div
        className={classNames('phone-field', 'b-field', this.props.className, {
          'is-invalid': this.props.touched && this.props.error,
        })}
        key={this.props.country}
      >
        <label className="phone-field__wrapper" htmlFor={this.props.name}>
          <PhoneInput
            className="phone-field__input"
            id={this.props.name}
            name={this.props.name}
            value={this.props.value}
            defaultCountry={this.props.country.toLowerCase()}
            placeholder={this.props.placeholder}
            onChange={(value, a) => {
              if (this.props.callback) {
                this.props.callback(a.name)
              }
              this.props.onChange(this.props.name, value)
            } }
            onBlur={this.props.handleBlur}
            disableAreaCodes
          />
        </label>
        {this.props.touched && this.props.error && <div className="phone-field__error">{this.props.error}</div>}
        {this.props.note && <div className="phone-field__note">{this.props.note}</div>}
      </div>
    )
  }
}

// PhoneField.propTypes = {
//   country: PropTypes.string,
//   className: PropTypes.string,
//   name: PropTypes.string.isRequired,
//   touched: PropTypes.bool,
//   error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
//   value: PropTypes.string.isRequired,
//   label: PropTypes.string,
//   placeholder: PropTypes.string,
//   handleChange: PropTypes.func.isRequired,
//   handleBlur: PropTypes.func,
//   note: PropTypes.string,
// }

// PhoneField.defaultProps = {
//   country: 'us',
//   className: '',
//   touched: false,
//   error: '',
//   label: '',
//   placeholder: '',
//   note: '',
//   handleBlur: null,
// }

export default PhoneField
